import React from 'react';
import { TextField as MuiTextField, Typography } from '@mui/material';
import { BaseField } from './BaseField';
import type { BaseFieldProps } from './types';

/**
 * Long text field component that handles:
 * - long_text (form-builder)
 * - textarea (legacy)
 */
export const LongTextField: React.FC<BaseFieldProps> = ({
  field,
  value = '',
  onChange,
  onBlur,
  mode = 'edit',
  error,
  touched,
  sx,
  showLabel = true,
  disabled,
}) => {
  // Extract field properties based on field format
  const label = 'label' in field ? field.label : '';
  const required = 'required' in field ? field.required : false;
  
  // Determine number of rows
  const rows = 'rows' in field && field.rows ? field.rows : 4;

  // Extract placeholder
  const placeholder = 'placeholder' in field ? field.placeholder : label ? `Enter ${label.toLowerCase()}` : 'Enter text';

  // Handle display mode
  if (mode === 'display') {
    return (
      <BaseField field={field} mode={mode} sx={sx} showLabel={showLabel}>
        <Typography 
          variant="body2" 
          sx={{ whiteSpace: 'pre-wrap' }}
        >
          {value || '-'}
        </Typography>
      </BaseField>
    );
  }

  // Handle edit/preview modes
  return (
    <BaseField
      field={field}
      mode={mode}
      error={error}
      touched={touched}
      sx={sx}
      showLabel={false}
      disabled={disabled}
    >
      <MuiTextField
        fullWidth
        label={showLabel ? label : undefined}
        value={value}
        onChange={onChange ? (e) => onChange(e.target.value) : undefined}
        onBlur={onBlur}
        disabled={disabled || mode === 'preview'}
        required={required}
        error={!!(touched && error)}
        helperText={touched && error ? error : undefined}
        placeholder={placeholder}
        variant="outlined"
        size="small"
        multiline
        rows={rows}
      />
    </BaseField>
  );
};